export default __webpack_public_path__ + "static/media/mockflow.f82f31a4.svg";